class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    // price range filter
    this.querySelector('form .range__field')?.addEventListener(
      'priceRange',
      this.debouncedOnSubmit.bind(this)
    );

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
    // on refresh setup price range values
    let urlString = window.location.href,
      url = new URL(urlString),
      maxPrice = url.searchParams.get('filter.v.price.lte'),
      minPrice = url.searchParams.get('filter.v.price.gte');
    FacetFiltersForm.setUpPriceRange(minPrice, maxPrice);

    //sort update
    FacetFiltersForm.updateSort();
  }

  static updateSort() {
    let sortItems = document.querySelectorAll(
      '.sort-items__wrapper .sort-items__option'
    );

    if (sortItems) {
      sortItems.forEach((element) => {
        element.addEventListener('click', function (e) {
          var filterForm = document.querySelector('form#FacetFiltersForm');
          filterForm.querySelector('[name="sort_by"]').value =
            element.dataset.value;
          filterForm.dispatchEvent(new Event('input', { bubbles: true }));
          //remove is active class
          sortItems.forEach((item) => {
            if (item.classList.contains('is-active')) {
              item.classList.remove('is-active');
            }
          });
          //add active to clicked item
          if (!element.classList.contains('is-active')) {
            element.classList.add('is-active');
          }
          if (
            document.querySelectorAll(
              `.sort-items__wrapper .sort-items__option[data-value="${element.dataset.value}"]`
            )
          ) {
            document
              .querySelectorAll(
                `.sort-items__wrapper .sort-items__option[data-value="${element.dataset.value}"]`
              )
              .forEach((item) => {
                if (!item.classList.contains('is-active')) {
                  item.classList.add('is-active');
                }
              });
          }
        });
      });
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static setUpPriceRange(minPrice, maxPrice) {
    let rangeSliderElement = document.querySelector('#range-slider-example'),
      rangeSliderMobile = document.querySelector(
        '#range-slider-example-mobile'
      ),
      desktopRangeParent = document.getElementById('FacetFiltersForm'),
      mobileRangeParent = document.getElementById('FacetFiltersFormMobile');

    FacetFiltersForm.rangeSliderElementCreate(
      rangeSliderElement,
      minPrice,
      maxPrice,
      desktopRangeParent
    );
    FacetFiltersForm.rangeSliderElementCreate(
      rangeSliderMobile,
      minPrice,
      maxPrice,
      mobileRangeParent
    );
  }

  static rangeSliderElementCreate(selector, minPrice, maxPrice, parent) {
    let minValue = minPrice ? minPrice : window.priceRanges.min,
      maxValue = maxPrice ? maxPrice : window.priceRanges.max,
      minValueText = parent.querySelector('.range-min-value span'),
      maxValueText = parent.querySelector('.range-max-value span');
    if (minValueText) minValueText.innerHTML = minValue;
    if (maxValueText) maxValueText.innerHTML = maxValue;
    if (selector)
      rangeSlider(selector, {
        // min value
        min: window.priceRanges.min,
        // max value
        max: window.priceRanges.max,

        // step size
        step: 5,
        // initial values
        value: [minValue, maxValue],
        // disable the range slider element
        disabled: false,
        // disable the range slider
        rangeSlideDisabled: false,
        // disable left/right (top/bottom) thumbs
        thumbsDisabled: [false, false],
        // or 'vertical'
        orientation: 'horizontal',
        // callback function
        onInput: function (valueSet) {
          let numberS = parent.querySelectorAll('.range__field'),
            minValueText = parent.querySelector('.range-min-value span'),
            maxValueText = parent.querySelector('.range-max-value span');
          numberS[0].value = valueSet[0];
          numberS[1].value = valueSet[1];
          minValueText.innerHTML = valueSet[0];
          maxValueText.innerHTML = valueSet[1];
          numberS[0].dispatchEvent(new Event('priceRange'));
          numberS[1].dispatchEvent(new Event('priceRange'));
        },
      });
  }

  static renderPage(
    searchParams,
    event,
    updateURLHash = true,
    lowPrice = window.priceRanges.min,
    highPrice = window.priceRanges.max
  ) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById(
      'ProductCountDesktop'
    );
    document
      .getElementById('ProductGridContainer')
      .querySelector('.collection')
      .classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);

    setTimeout(() => {
      FacetFiltersForm.setUpPriceRange(lowPrice, highPrice);
      let facetForm = document.querySelector('facet-filters-form');
      let facetFormMobile = document.querySelector(
        'facet-filters-form.facet-filters-form-mobile'
      );
      facetForm
        .querySelector('form .range__field')
        ?.addEventListener(
          'priceRange',
          facetForm.debouncedOnSubmit.bind(this)
        );
      facetFormMobile
        .querySelector('form .range__field')
        ?.addEventListener(
          'priceRange',
          facetFormMobile.debouncedOnSubmit.bind(this)
        );
      updateSort();
    }, 1500);

    //[Addition] Update select width, depends on selected text width - Desktop only
    if (window.matchMedia('(min-width: 750px)').matches) {
      setTimeout(() => {
        this.updateSelectWidth();
      }, 1000);
    }
    //[Addition] Update select width, depends on selected text width - Desktop only
  }

  static updateSelectWidth() {
    var selectElem = document.querySelector('.facet-filters.sorting select');

    if (selectElem) {
      var selectedText = selectElem.options[selectElem.selectedIndex].text;
      if (selectedText.length > 10)
        selectElem.style.width = selectedText.length * 8 + 'px';
      else {
        selectElem.style.width = 20 + selectedText.length * 8 + 'px';
      }
    }
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function')
          initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function')
      initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter
        ? element.dataset.index === jsFilter.dataset.index
        : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(
      (element) => !matchesIndex(element)
    );
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(
        `.js-filter[data-index="${element.dataset.index}"]`
      ).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender)
      FacetFiltersForm.renderCounts(
        countsToRender,
        event.target.closest('.js-filter')
      );
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      '.active-facets-mobile',
      '.active-facets-desktop',
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      '.mobile-facets__open',
      '.mobile-facets__count',
      '.sorting',
    ];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML;
    });

    document
      .getElementById('FacetFiltersFormMobile')
      .closest('menu-drawer')
      .bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML =
        source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML =
        source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      '',
      `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`
    );
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    // don't filter prices with the default price range.
    if (
      formData.get('filter.v.price.gte') == window.priceRanges.min &&
      formData.get('filter.v.price.lte') == window.priceRanges.max
    ) {
      formData.delete('filter.v.price.gte');
      formData.delete('filter.v.price.lte');
    }

    FacetFiltersForm.renderPage(
      searchParams,
      event,
      true,
      formData.get('filter.v.price.gte'),
      formData.get('filter.v.price.lte')
    );
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll(
      'facet-filters-form form'
    );
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(
        event.target.closest('form')
      );
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile =
        event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (
            form.id === 'FacetSortForm' ||
            form.id === 'FacetFiltersForm' ||
            form.id === 'FacetSortDrawerForm'
          ) {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf('?') + 1
          );
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '')
      minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form =
      this.closest('facet-filters-form') ||
      document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
